if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
        // Toit de Paris : fin de la compensation de la barre de defilement.
        if (this.tdpPagePlace) this.tdpPagePlace.disconnect();
        this.tdpPagePlace = null;
        document.body.style.paddingRight = '';
        if (this.tdpFitObserver) this.tdpFitObserver.disconnect();
        this.tdpFitObserver = null;
      }

      // Toit de Paris : aucun defilement dans la fenetre (quick-add.css). Si la
      // fiche ne tient pas, elle est reduite juste assez pour tout afficher :
      // la colonne de droite seule quand l'image tient a cote, sinon toute la
      // fiche. Recalcule a chaque changement de taille (gravure, variante...).
      tdpFit() {
        const productInfo = this.modalContent.querySelector('product-info');
        if (!productInfo || !this.hasAttribute('open')) return;
        const info = productInfo.querySelector('.product__info-wrapper');
        const media = productInfo.querySelector('.product__media-wrapper');
        [productInfo, info].forEach((element) => {
          if (!element) return;
          element.style.transform = '';
          element.style.transformOrigin = '';
          element.style.marginBottom = '';
        });
        this.modalContent.scrollTop = 0;

        // Bas de la zone utile : celui de la fenetre ; entre 750 et 989 px, la
        // fenetre suit son contenu, la limite est alors le bas de l'ecran (meme
        // marge qu'en haut).
        const style = getComputedStyle(this.modalContent);
        const modalBox = this.modalContent.closest('.quick-add-modal__content');
        let bottom = this.modalContent.getBoundingClientRect().bottom - parseFloat(style.paddingBottom);
        if (modalBox && window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches) {
          bottom = window.innerHeight - parseFloat(getComputedStyle(modalBox).marginTop) - parseFloat(style.paddingBottom);
        }

        let target = productInfo;
        if (info && media) {
          const infoTop = info.getBoundingClientRect().top;
          const mediaBox = media.getBoundingClientRect();
          if (Math.abs(infoTop - mediaBox.top) < 2 && this.tdpContentBottom(media) <= bottom + 1) target = info;
        }
        const top = target.getBoundingClientRect().top;
        const height = this.tdpContentBottom(target) - top;
        const scale = Math.min(1, (bottom - top) / height);
        if (scale >= 1) return;
        const reduced = Math.floor(scale * 1000) / 1000;
        target.style.transformOrigin = target === info ? 'top left' : 'top center';
        target.style.transform = `scale(${reduced})`;
        target.style.marginBottom = `${height * reduced - target.offsetHeight}px`;
      }

      // Bas du dernier element affiche : textes, images, champs, boutons et
      // cadres visibles, pas les conteneurs vides etires par la mise en page,
      // ni ce qui est masque (menu ferme, element coupe par son conteneur),
      // ni la fenetre de gravure et les menus deroulants, ouverts par-dessus.
      tdpContentBottom(element) {
        let bottom = element.getBoundingClientRect().top;
        const walk = (parent, clip, inDetails) => {
          for (const child of parent.children) {
            if (child.tagName === 'DIALOG') continue;
            const style = getComputedStyle(child);
            if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') continue;
            if (inDetails && style.position === 'absolute') continue;
            const box = child.getBoundingClientRect();
            if (child.tagName === 'DETAILS' && !child.open) {
              const summary = child.querySelector(':scope > summary');
              if (summary) bottom = Math.max(bottom, Math.min(summary.getBoundingClientRect().bottom, clip));
              continue;
            }
            const framed =
              !child.children.length ||
              /^(BUTTON|SELECT|LABEL|A|IMG|SVG|VIDEO|IFRAME)$/i.test(child.tagName) ||
              parseFloat(style.borderBottomWidth) > 0 ||
              style.backgroundImage !== 'none' ||
              !/^(transparent|rgba\(0, 0, 0, 0\))$/.test(style.backgroundColor);
            if (framed && box.height && box.top < clip) bottom = Math.max(bottom, Math.min(box.bottom, clip));
            const clips = style.overflowY !== 'visible' || style.overflowX !== 'visible';
            walk(child, clips ? Math.min(clip, box.bottom) : clip, inDetails || child.tagName === 'DETAILS');
          }
        };
        walk(element, Infinity, false);
        return bottom;
      }

      // Un menu deroulant ouvert (liste des arrondissements...) reste entier
      // dans la fenetre : sa liste, qui defile deja dans son cadre, est
      // raccourcie si besoin.
      tdpFitMenu(event) {
        const details = event.target;
        if (details.tagName !== 'DETAILS' || !details.open) return;
        const limit = this.modalContent.getBoundingClientRect().bottom - 10;
        details.querySelectorAll(':scope > :not(summary)').forEach((panel) => {
          if (getComputedStyle(panel).position !== 'absolute') return;
          panel.style.maxHeight = '';
          const box = panel.getBoundingClientRect();
          if (box.bottom <= limit || !box.height) return;
          panel.style.maxHeight = `${((limit - box.top) * panel.offsetHeight) / box.height}px`;
        });
      }

      tdpWatchFit() {
        if (!this.tdpFitMenuListener) {
          this.tdpFitMenuListener = (event) => this.tdpFitMenu(event);
          this.modalContent.addEventListener('toggle', this.tdpFitMenuListener, true);
        }
        if (this.tdpFitObserver) this.tdpFitObserver.disconnect();
        let frame = 0;
        this.tdpFitObserver = new ResizeObserver(() => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.tdpFit());
        });
        this.tdpFitObserver.observe(this.modalContent);
        this.modalContent
          .querySelectorAll('.product__media-wrapper, .product__info-container')
          .forEach((element) => this.tdpFitObserver.observe(element));
        this.tdpFit();
      }

      // Toit de Paris : la fenetre masque la barre de defilement de la page
      // (classe overflow-hidden) ; tant qu'elle est masquee, sa largeur est
      // compensee pour que la page de fond ne bouge pas.
      tdpKeepPagePlace(scrollbar) {
        if (this.tdpPagePlace) this.tdpPagePlace.disconnect();
        if (scrollbar <= 0) return;
        this.tdpPagePlace = new MutationObserver(() => {
          document.body.style.paddingRight = document.body.classList.contains('overflow-hidden') ? `${scrollbar}px` : '';
        });
        this.tdpPagePlace.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        // Toit de Paris : fiche deja prechargee si possible (voir tdpQuickAddPage).
        tdpQuickAddPage(opener.getAttribute('data-product-url'))
          .then((responseText) => {
            // Toit de Paris : largeur de la barre de defilement, avant que la
            // fenetre ne la masque (voir tdpKeepPagePlace).
            const scrollbar = window.innerWidth - document.documentElement.clientWidth;
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

            this.tdpKeepPagePlace(scrollbar);
            super.show(opener);
            this.tdpWatchFit();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );

  // Toit de Paris : fenetres d'ajout rapide ouvertes sans attente. La fiche des
  // produits visibles est prechargee une fois la page chargee (une a la fois),
  // ou des que leur bouton est survole ou touche, avec les scripts et styles
  // qu'elle charge (Mapbox pour le Carre Personnalise). Au clic, la fenetre
  // utilise cette fiche au lieu de la redemander. Une fiche sert 5 min au plus
  // et est oubliee a chaque ajout au panier.
  const tdpQuickAddPages = new Map();
  const tdpPrefetchedAssets = new Set();

  function tdpQuickAddPage(url) {
    const cached = tdpQuickAddPages.get(url);
    if (cached && Date.now() - cached.time < 5 * 60 * 1000) return cached.page;
    const page = fetch(url).then((response) => {
      if (!response.ok) tdpQuickAddPages.delete(url);
      return response.text();
    });
    tdpQuickAddPages.set(url, { time: Date.now(), page });
    page.then(tdpPrefetchAssets, () => tdpQuickAddPages.delete(url));
    return page;
  }

  // Scripts et styles de la fiche (ceux que la fenetre chargera), mis en cache.
  function tdpPrefetchAssets(text) {
    const start = text.indexOf('<product-info');
    const end = text.lastIndexOf('</product-info>');
    if (start < 0 || end < start) return;
    const html = text.slice(start, end);
    const urls = [];
    html.replace(/<script\b[^>]*\ssrc="([^"]+)"/g, (tag, src) => urls.push(src));
    html.replace(/<link\b[^>]*\srel="stylesheet"[^>]*>/g, (tag) => {
      const href = tag.match(/\shref="([^"]+)"/);
      if (href) urls.push(href[1]);
    });
    urls.forEach((url) => {
      url = url.replace(/&amp;/g, '&');
      if (tdpPrefetchedAssets.has(url)) return;
      tdpPrefetchedAssets.add(url);
      fetch(url, { mode: 'no-cors', credentials: 'include' }).catch(() => {});
    });
  }

  // Adresse de la fiche si l'element est (dans) un bouton d'ajout rapide.
  function tdpQuickAddUrl(element) {
    const opener = element && element.closest && element.closest('modal-opener');
    const button = opener && opener.querySelector('button[data-product-url]');
    const modal = button && document.querySelector(opener.getAttribute('data-modal'));
    return modal && modal.tagName === 'QUICK-ADD-MODAL' ? button.getAttribute('data-product-url') : null;
  }

  ['pointerover', 'focusin'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        const url = tdpQuickAddUrl(event.target);
        if (url) tdpQuickAddPage(url).catch(() => {});
      },
      { capture: true, passive: true }
    );
  });

  const tdpConnection = navigator.connection;
  const tdpSaveData = tdpConnection && (tdpConnection.saveData || /2g/.test(tdpConnection.effectiveType || ''));
  if (!tdpSaveData && 'IntersectionObserver' in window) {
    let queue = Promise.resolve();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const url = tdpQuickAddUrl(entry.target);
          if (url) queue = queue.then(() => tdpQuickAddPage(url).catch(() => {}));
        });
      },
      { rootMargin: '200px 0px' }
    );
    const observeButtons = () =>
      (window.requestIdleCallback || ((callback) => setTimeout(callback, 200)))(
        () => document.querySelectorAll('modal-opener button[data-product-url]').forEach((button) => observer.observe(button)),
        { timeout: 3000 }
      );
    if (document.readyState === 'complete') observeButtons();
    else window.addEventListener('load', observeButtons, { once: true });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => tdpQuickAddPages.clear());
  }
}
